(function () {
  var API_BASE = 'https://auth-dash.swau.com/api';

  function getQuery(query) {
    var url = API_BASE + '/public/pop-search/' + encodeURIComponent(query);
    $.ajax({
      url: url,
      type: 'GET',
      success: function (response) {
        if (Array.isArray(response) && response.length) {
          showResults(response);
        } else {
          showNoResults();
        }
      },
      error: function () {
        showNoResults();
      },
    });
  }

  function showResults(response) {
    document.getElementById('inputContainer').style.display = 'none';
    document.getElementById('noResultsContainer').style.display = 'none';
    document.getElementById('resultsContainer').style.display = 'flex';

    var table = document.getElementById('resultsTable');
    while (table.rows.length > 1) table.rows[1].remove();

    for (var i = 0; i < response.length; i++) {
      var data = response[i];
      var newRow = table.insertRow();
      var cell1 = newRow.insertCell();
      var cell2 = newRow.insertCell();
      var cell3 = newRow.insertCell();
      var cell4 = newRow.insertCell();
      var cell5 = newRow.insertCell();
      var cell6 = newRow.insertCell();

      if (data.photo) {
        var img = document.createElement('img');
        img.src = data.photo;
        img.alt = data.funkoName || 'Funko POP';
        img.classList.add('tablePhoto');
        cell1.appendChild(img);
      } else {
        cell1.textContent = '—';
      }

      cell2.textContent = data.funkoName || '—';
      cell3.textContent = data.funkoRarity || 'N/A';
      cell4.textContent = data.funkoExclusive || 'N/A';
      cell5.textContent = data.averageGrade != null ? data.averageGrade : 'N/A';
      cell6.textContent = data.totalCount != null ? data.totalCount : '0';
    }
  }

  function showNoResults() {
    document.getElementById('inputContainer').style.display = 'none';
    document.getElementById('resultsContainer').style.display = 'none';
    document.getElementById('noResultsContainer').style.display = 'flex';
  }

  function reset() {
    document.getElementById('noResultsContainer').style.display = 'none';
    document.getElementById('resultsContainer').style.display = 'none';
    document.getElementById('inputContainer').style.display = 'flex';
  }

  function searchClicked() {
    var inputQuery = (document.getElementById('searchInput').value || '').trim();
    if (!inputQuery) {
      alert('You must enter a POP name or number!');
      return;
    }
    getQuery(inputQuery);
  }

  // Expose for inline handlers in page.pop-report.liquid
  window.getQuery = getQuery;
  window.showResults = showResults;
  window.showNoResults = showNoResults;
  window.reset = reset;
  window.searchClicked = searchClicked;
})();
